import core from './core';
import Tracker from '../helpers/tracker';
import { DeviceManager } from './DeviceManager';
import { TrackingData } from '../helpers/TrackingTypes';
import { GA4PDPTracker } from './GA4/GA4PDPTracker';

export default core.extend({
	constructor() {
		this.config = {
			body: 'body',
			classOpen: 'share-open',
			page: '.page',
			overlay: '.share-page-overlay',
			mobileLink: '.share-social',
			popup: '.share-popup',
		};

		this.deviceManager = new DeviceManager();

		this.attachEvents();
	},

	attachEvents() {
		_.bindAll(this, 'renderMobileView');

		jQuery(this.config.mobileLink).on('click', this.renderMobileView);

		jQuery(this.config.popup).on('click', 'a', this.clickShareLink);

		jQuery(document).on('click', this.config.overlay, () => this.togglePopup());

		jQuery(window).on('scroll', () => {
			if (this.isPopupOpened()) {
				this.togglePopup();
			}
		});

		this.deviceManager.addEventListener('device:width:changed', () =>
			jQuery(this.config.body).removeClass(this.config.classOpen)
		);
	},

	togglePopup() {
		const body = jQuery(this.config.body);

		body.toggleClass(this.config.classOpen);
	},

	isPopupOpened() {
		return jQuery(this.config.body).hasClass(this.config.classOpen);
	},

	clickShareLink(elem) {
		const popupOptions =
			'left=300, top=300, scrollbars=yes, status=no, toolbar=yes, resizable=yes, width=500, height=400';

		let navigateUrl;
		const productUrl = encodeURIComponent(elem.target.href);
		const href = elem.target.getAttribute('data-href');
		const channelName = elem.target.getAttribute('data-name');

		if (channelName === 'Pinterest') {
			const productImage = encodeURIComponent(jQuery('.product-img')[0].src);
			const descriptionPosition = href.indexOf('description') - 1;

			navigateUrl = href.substr(0, descriptionPosition) + productImage + href.substr(descriptionPosition);
			const mediaPosition = navigateUrl.indexOf('media') - 1;

			navigateUrl = navigateUrl.substr(0, mediaPosition) + productUrl + navigateUrl.substr(mediaPosition);
		} else {
			navigateUrl = href + productUrl;
		}

		if (channelName === 'Whatsapp' || channelName === 'Email') {
			location.href = navigateUrl;
		} else {
			window.open(navigateUrl, channelName, popupOptions);
		}

		Tracker.track({
			category: TrackingData.PAGE_PDP,
			action: TrackingData.ACTION_SHARED_LINK,
			label: elem.target.name,
		});

		GA4PDPTracker.trackPdpSocialNetworkEvent(channelName);
	},

	renderMobileView() {
		const body = jQuery(this.config.body);

		this.togglePopup();

		if (!body.find(this.config.overlay).length) {
			body.find(this.config.page).append(`<div class="${this.config.overlay.substring(1)}" />`);
		}

		Tracker.track({
			category: TrackingData.PAGE_PDP,
			action: TrackingData.ACTION_OPEN_SHARE_PANEL,
		});
	},
});
